import styled from "styled-components/macro";
import { NavLink } from "react-router-dom";

export const Nav = styled.nav`
  background: #ff9767;
  height: 120px;
  width: 100%;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LogoLink = styled(NavLink)`
  text-decoration: none;

  img {
    color: #fff;
  }
`;

export const IconContainer = styled.div`
  .icon {
    margin-right: 20px;
    font-size: 40px;
    color: #fff;
  }
`;

const activeClassName = "nav-item-active";
export const PageLink = styled(NavLink).attrs({ activeClassName })`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  padding: 10px 0;

  &.${activeClassName} {
    color: #8b0000;
  }

  &:hover {
    color: #8b0000;
    transition: 0.3s ease;
  }
`;

export const OuterPageLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  padding: 10px 0;

  &:active {
    color: #8b0000;
  }

  &:hover {
    color: #8b0000;
    transition: 0.3s ease;
  }
`;

export const Navbar = styled.ul`
  list-style: none;
  display: flex;
  z-index: 5;

  @media only screen and (max-width: 1149px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ff9767;
    position: fixed;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
    margin-top: 0;
    top: 0;
    right: 0;
    height: 360px;
    width: 100%;
    padding-top: 3rem;
    padding-bottom: 1rem;
    transition: transform 0.3s ease-in-out;

    li {
      margin-top: 0;
    }
  }
  @media (min-width: 1149px) {
    flex-direction: row;
    width: 75%;
    justify-content: space-between;
  }
  @media (min-width: 1391px) {
    width: 70%;
  }
  @media (min-width: 1639px) {
    width: 65%;
  }

  li {
    margin: 0 15px;
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1149px) {
    flex-direction: row;
  }
`;

export const StyledBurger = styled.div`
  width: 3rem;
  height: 2rem;
  top: 15px;
  right: 20px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  border-radius: 5%;
  @media (min-width: 1149px) {
    display: none;
  }

  div {
    border-radius: 10px;
    width: 2rem;
    height: 0.25rem;
    background: ${({ open }) => (open ? "#fff" : "#fff")};
    transform-origin: 1px;
    transition: all 0.3s linear;

    &:nth-child(1) {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }

    &:nth-child(2) {
      transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
      opacity: ${({ open }) => (open ? 0 : 1)};
    }

    &:nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }

    @media (min-width: 1149px) {
      display: none;
    }
  }
`;
